
import { useReferenceTypesContext } from "./ReferenceTypes/ReferenceTypesContext";
import { useStaleAwareDataContext } from "./useStaleAwareDataContext";


export const UseReferenceTypeStaleAwareData = () => {
  const ctx = useReferenceTypesContext();

  return useStaleAwareDataContext({
    data: ctx.data,
    lastLoaded: ctx.lastLoaded,
    reload: ctx.reload,
    isLoading: ctx.isLoading
  });
};